module.exports = __webpack_public_path__ + "media/assets/icons/explanation_of_bulk_quote_2-4cf879338bb91d6e3bcf1bdcbaed5fdd.svg";